export const SET_UNREAD_COUNT_BY_GROUP = "SET_UNREAD_COUNT_BY_GROUP";
export const INCREMENT_UNREAD_COUNT = "INCREMENT_UNREAD_COUNT";
export const DECREMENT_UNREAD_COUNT = "DECREMENT_UNREAD_COUNT";

export const STARTUP_NOTIFICATION = "STARTUP_NOTIFICATION";
